<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    
    <div class="form-group row">     
        <div
          class="col-lg-3"
        >
          <button
            type="button"
            class="btn btn-outline-primary"
            (click)="anexNew()"
            [disabled]=!AnexDostupan
            ngbTooltip="{{'ANGAZOVANJERO.ANEKS.TOOLTIP.NEW' | translate }}"            
          >
            <i class="fa fa-fw fa-plus"></i>
            <span>{{'ANGAZOVANJERO.ANEKS.SHORT' | translate }}</span>
          </button>
        </div>
        <div
          class="col-lg-3"
          *ngIf="baseFormGroup.get('ImaAnex').value"
        >
          <button
            type="button"
            class="btn btn-outline-primary"
            (click)="anexEdit()"
            [disabled]=!AnexDostupan
            ngbTooltip="{{'ANGAZOVANJERO.ANEKS.TOOLTIP.EDIT' | translate }}"            
            >
            <i class="fa fa-fw fa-pencil-alt"></i>
            <span >
              {{'ANGAZOVANJERO.ANEKS.SHORT' | translate }}
            </span>
            <span *ngIf="baseFormGroup && baseFormGroup.get('BrojAnexa') && baseFormGroup.get('BrojAnexa').value">
              ({{baseFormGroup.get("BrojAnexa").value}})
            </span>
          </button>
        </div>
        <div class="col-lg-3"></div>
        <div
          class="col-lg-3"
          *ngIf="!baseFormGroup.get('ImaRaskid').value"
        >
          <button
            type="button"
            class="btn btn-outline-primary"
            (click)="raskidEdit()"
            [disabled]=!RaskidDostupan
            ngbTooltip="{{'ANGAZOVANJERO.RESENJE.TOOLTIP.NEW' | translate }}"            
          >
            <i class="fa fa-fw fa-plus"></i>
            <span >{{'ANGAZOVANJERO.RESENJE.SHORT' | translate }}</span>
          </button>
        </div>   
        <div
          class="col-lg-3"
          *ngIf="baseFormGroup.get('ImaRaskid').value"          
        >
          <button
            type="button"
            class="btn btn-outline-primary"
            (click)="raskidEdit()"
            [disabled]=!RaskidDostupan
            ngbTooltip="{{'ANGAZOVANJERO.RESENJE.TOOLTIP.EDIT' | translate }}"            
          >
            <i class="fa fa-fw fa-pencil-alt"></i>
            <span >{{'ANGAZOVANJERO.RESENJE.SHORT' | translate }}</span>
          </button>
        </div>   
      </div>
    <div class="form-group row">
      <div class="col-md-12">
        <yt-dropdown-picklist
          [ModelName]="'podvrstadokumentastavka'"
          [GetName]="'GetByUrl'"
          [ModelProperty]="'Sifra,Naziv'"
          [GetParameters] = "[{ Name: 'url', Value: '/kad/angazovanjero' }]"
          [OrderBy]="'Naziv'"
          [AllowAddNew]="false"
          formControlName="PodvrstaDokumentaStavkaID"
          [Label]="'ANGAZOVANJERO.PODVRSTADOKUMENTASTAVKA.SINGULAR'"
          (OnItemSelected)="onPodvrstaDokumentaStavkaSelected($event)"
        >
        </yt-dropdown-picklist>
      </div>
    </div>
        
    <div class="form-group row">
      <div class="col-md-6">
        <yt-fw-date-picker-popup
              formControlName="Datum"
              name="txtDatum" 
              [Label]="'DOKUMENT.DATUM.SINGULAR'"
              [ngClass]="{'is-invalid': submitted && fc.Datum.invalid}"
              (OnDateSelected)="onDatumChange($event)"
        >
        </yt-fw-date-picker-popup>
      </div>  
      <div class="col-md-6">
        <div class="input-group">
          <yt-input
            [Type]="'text'"
            [Label]="'ANGAZOVANJERO.BROJ.SINGULAR'"
            formControlName="Broj"            
            [ngClass]="{'is-invalid': submitted && fc.Broj.invalid}">
          </yt-input>
          <!-- <div class="input-group-append">
            <span class="span-control">/</span><span *ngIf="baseFormGroup.get('Datum').value != null" class="span-control">{{baseFormGroup.get('Datum').value.year}}</span>
          </div> -->
        </div>
      </div>
 

    </div>  

    <div class="form-group row">      
      <div class="col-md-6">
        <yt-dropdown-picklist
            [ModelName]="'statusro'"
            [GetName]="'get'"
            [ModelProperty]="'Naziv'"
            [OrderBy]="'Naziv'"
            [AllowAddNew]='true'
            formControlName="StatusRoID"                                   
            [ngClass]="{'is-invalid': submitted && fc.StatusRoID.invalid}"
            [Label]="'ANGAZOVANJERO.STATUSRO.SINGULAR'"
            (OnItemSelected)="onStatusROSelected($event)"
            (GetItems)="StatusRoGetItems($event)"
        >
        </yt-dropdown-picklist>
        <div class="form-error" *ngIf="submitted && fc.StatusRoID.invalid">
            <span *ngFor="let validation of errorMessages.StatusRoID">
            <span class="error-message" *ngIf="fc.StatusRoID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
            </span>
        </div>
      </div> 
      <div class="col-md-3">
        <yt-fw-date-picker-popup
            name="txtOdDatuma"
            formControlName="OdDatuma"
            [ngClass]="{'is-invalid' : submitted && fc.OdDatuma.invalid}"
            [Label]="'ANGAZOVANJERO.ODDATUMA.SINGULAR'">
        </yt-fw-date-picker-popup>
        <div class="form-error" *ngIf="submitted && fc.OdDatuma.invalid">
            <span *ngFor="let validation of errorMessages.OdDatuma">
                <span class="error-message" *ngIf="fc.OdDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
            </span>
        </div>
      </div>

      <div class="col-md-3">
          <yt-fw-date-picker-popup
              name="txtDoDatuma"
              formControlName="DoDatuma"
              [ngClass]="{'is-invalid' : submitted && fc.DoDatuma.invalid}"
              [Label]="'ANGAZOVANJERO.DODATUMA.SINGULAR'">
          </yt-fw-date-picker-popup>
          <div class="form-error" *ngIf="submitted && fc.DoDatuma.invalid">
              <span *ngFor="let validation of errorMessages.DoDatuma">
                  <span class="error-message" *ngIf="fc.DoDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
          </div>
        </div>
  </div>    


    <!-- Ovde treba da idu nezaposleni umesto osoba -->
    <div class="form-group row">
      <div class="col-md-6">
        <yt-dropdown-picklist [ModelName]="'osoba'" [GetName]="'get'" [ModelProperty]="'Prezime,Ime,Jmbg'"
          [OrderBy]="'Prezime'" [AllowAddNew]="true" formControlName="OsobaID" [Label]="'ANGAZOVANJERO.OSOBA.SINGULAR'">
        </yt-dropdown-picklist>
      </div>
      <div class="col-md-6">
        <yt-dropdown-picklist [ModelName]="'radnomesto'" [GetName]="'getRoot'" [ModelProperty]="'Naziv'" [OrderBy]="'Naziv'"
          formControlName="RadnoMestoID" [AllowAddNew]="true" [Type]="'treeview'"
          [Label]="'ANGAZOVANJERO.RADNOMESTO.SINGULAR'" [ngClass]="{'is-invalid': submitted && fc.RadnoMestoID.invalid}">
        </yt-dropdown-picklist>
      </div>
    </div>
    
    <div class="form-group row">
      <div class="col-md-6">
        <button
         type="button"
         class="btn btn-outline-primary"
         (click)="unosPoslova()"
         [disabled]=!UnosPoslovaDostupan
         ngbTooltip="{{'ANGAZOVANJERO.POSLOVI.EDIT' | translate }}"
        >
          <i class="fa fa-fw fa-list"></i>
          <span>{{'ANGAZOVANJERO.POSLOVI.SHORT' | translate }}</span>
        </button>
      </div>
    
      <div class="col-md-6">
        <yt-autocomplete [ModelName]="'mesto'" [GetName]="'getByNaziv'" [ModelProperty]="'Naziv'" [OrderBy]="'Naziv'"
          [Label]="'ANGAZOVANJERO.MESTORADA.SINGULAR'" formControlName="MestoRadaID">
        </yt-autocomplete>
        <div class="form-error" *ngIf="submitted && fc.MestoRadaID.invalid">
          <span *ngFor="let validation of errorMessages.MestoRadaID">
            <span class="error-message" *ngIf="fc.MestoRadaID.hasError(validation.type)">
              <span translate="{{validation.message}}"></span>
            </span>
          </span>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-6">
        <yt-dropdown-picklist
            [ModelName]="'radnovreme'"
            [GetName]="'get'"
            [ModelProperty]="'Naziv'"
            [OrderBy]="'Naziv'"
            [AllowAddNew]='false'
            formControlName="RadnoVremeID"       
            [ngClass]="{'is-invalid': (submitted && fc.RadnoVremeID.invalid) || baseFormGroup.errors?.RadnoVremePrcAng}"
            [Label]="'ANGAZOVANJERO.RADNOVREME.SINGULAR'"
            (GetItems)="RadnoVremeGetItems($event)"
        >
        </yt-dropdown-picklist>
        <div class="form-error" *ngIf="submitted && fc.RadnoVremeID.invalid">
            <span *ngFor="let validation of errorMessages.RadnoVremeID">
            <span class="error-message" *ngIf="fc.RadnoVremeID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
            </span>
        </div>
        <div class="form-error" *ngIf="baseFormGroup.errors?.RadnoVremePrcAng?.valid==false">
          <span class="error-message">
              <span translate={{baseFormGroup.errors.RadnoVremePrcAng.message}}></span>
          </span>
        </div>
    </div>

      <div class="col-md-3">
        <div class="input-group">
          <yt-number-input-v3
            name="txtPrcAng"
            formControlName="PrcAng"
            [Label]="'ANGAZOVANJERO.PRCANG.SINGULAR'"
            (input)="onPrcAngChange($event)"
            [ngClass]="{'is-invalid': (submitted && fc.PrcAng.invalid) || baseFormGroup.errors?.RadnoVremePrcAng}"
          >
          </yt-number-input-v3>     
        </div>
      </div>
      <div class="col-md-3">
        <div class="input-group">
          <yt-number-input-v3            
            [Label]="'ANGAZOVANJERO.NEDFONDSATI.SINGULAR'"
            formControlName="NedFondSati"
            [FormatString]="'1.0-0'"
          >
          </yt-number-input-v3>     
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-4">
        <yt-number-input-v3
          name="txtKoefZarade"
          formControlName="KoefZarade"
          [Label]="'ANGAZOVANJERO.KOEFZARADE.SINGULAR'"
          [ngClass]="{'is-invalid': (submitted && fc.KoefZarade.invalid) || baseFormGroup.errors?.CenaRada}"
          >
        </yt-number-input-v3>
        <div class="form-error" *ngIf="baseFormGroup.errors?.CenaRada?.valid==false">
          <span class="error-message">
              <span translate={{baseFormGroup.errors.CenaRada.message}}></span>
          </span>
        </div>
      </div>
      <div class="col-md-4">
        <yt-dropdown-picklist
          [ModelName]="'beneficirani'"
          [GetName]="'get'"
          [ModelProperty]="'Naziv'"
          [OrderBy]="'Naziv'"
          [AllowAddNew]='false'
          formControlName="BeneficiraniID"          
          [ngClass]="{'is-invalid': submitted && fc.BeneficiraniID.invalid}"
          [Label]="'ANGAZOVANJERO.BENEFICIRANI.SINGULAR'">
        </yt-dropdown-picklist>
        <div class="form-error" *ngIf="submitted && fc.BeneficiraniID.invalid">
            <span *ngFor="let validation of errorMessages.BeneficiraniID">
            <span class="error-message" *ngIf="fc.BeneficiraniID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
            </span>
        </div>
      </div>
      <div class="col-md-4">
        <yt-number-input-v3
          name="txtBrojPoslodavaca"          
          [Label]="'ANGAZOVANJERO.BROJPOSLODAVACA.SINGULAR'"
          formControlName="BrojPoslodavaca"
          [FormatString]="'1.0-0'"
        >
        </yt-number-input-v3>
        <div class="form-error" *ngIf="fc.BrojPoslodavaca.invalid">
          <span *ngFor="let validation of errorMessages.BrojPoslodavaca">
            <!-- <span class="error-message" *ngIf="fc.BeneficiraniID.hasError(validation.type)"> -->
              <span translate="{{validation.message}}"></span>
            <!-- </span> -->
          </span>
        </div>        
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <yt-dropdown-picklist
          [ModelName]="'valuta'"
          [GetName]="'get'"
          [ModelProperty]="'Naziv'"
          [OrderBy]="'Naziv'"
          [AllowAddNew]='false'
          formControlName="ValutaID"
          [ngClass]="{'is-invalid': submitted && fc.ValutaID.invalid}"
          [Label]="'ANGAZOVANJERO.VALUTA.SINGULAR'">
        </yt-dropdown-picklist>
        <div class="form-error" *ngIf="submitted && fc.ValutaID.invalid">
            <span *ngFor="let validation of errorMessages.ValutaID">
            <span class="error-message" *ngIf="fc.ValutaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
            </span>
        </div>
      </div>
    </div>  

    <div class="form-group row">
      <div class="col-md-6">
        <yt-number-input-v3
          name="txtNetoZarada"
          formControlName="NetoZarada"
          [Label]="'ANGAZOVANJERO.NETOZARADA.SINGULAR'"
          [ngClass]="{'is-invalid': (submitted && fc.NetoZarada.invalid) || baseFormGroup.errors?.CenaRada}"
          >
        </yt-number-input-v3>
        
      </div>
      <div class="col-md-6">
        <yt-number-input-v3
          name="txtBrutoZarada"
          formControlName="BrutoZarada"
          [Label]="'ANGAZOVANJERO.BRUTOZARADA.SINGULAR'"
          [ngClass]="{'is-invalid': (submitted && fc.BrutoZarada.invalid) || baseFormGroup.errors?.CenaRada}"
          >
        </yt-number-input-v3>
      </div>

    </div>  

    <div class="form-group row">
      <div class="col-md-6">
        <yt-number-input-v3
          name="txtNetoCenaSata"
          formControlName="NetoCenaSata"
          [Label]="'ANGAZOVANJERO.NETOCENASATA.SINGULAR'"
          [ngClass]="{'is-invalid': (submitted && fc.NetoCenaSata.invalid) || baseFormGroup.errors?.CenaRada}"
          >
        </yt-number-input-v3>
      </div>
      <div class="col-md-6">
        <yt-number-input-v3
          name="txtBrutoCenaSata"
          formControlName="BrutoCenaSata"
          [Label]="'ANGAZOVANJERO.BRUTOCENASATA.SINGULAR'"
          [ngClass]="{'is-invalid': (submitted && fc.BrutoCenaSata.invalid) || baseFormGroup.errors?.CenaRada}"
          >
        </yt-number-input-v3>
      </div>
    </div>  
  </div>
</form>